/* @ngInject */
const blWagonsExcel = (
  excelUtils,
  excelStyles,
  computeWeight,
  types
) => {
  const self = {}

  const firstRow = 10

  self.generate = (sale, wagonsIds, options) => {
    return excelUtils.getWorkbook('blWagons2')
      .then((workbook) => {
        const sheet = workbook.sheet(0)
        self.setHeader(sheet, sale)
        self.setBody(sheet, sale.wagons, wagonsIds)
        const sheet2 = workbook.sheet(1)
        self.setHeader(sheet2, sale)
        self.setBody(sheet2, sale.wagons, wagonsIds)
        return workbook.outputAsync({
          type: '',
        })
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.download = (sale, options) => {
    return self.generate(sale, options)
      .then((blob) => {
        excelUtils.downloadWorkbook(blob, 'BL Wagons')
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.setHeader = (sheet, sale) => {
    self.getHeaderCells(sale).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.getHeaderCells = (_sale) => {
    return [{
      name: 'B7',
      value: _sale.date,
      type: types.date,
      style: { fontSize: 11, },
    }, {
      name: 'D7',
      value: _sale.number,
      style: { fontSize: 11, },
    }, {
      name: 'G7',
      value: _sale.owner,
      style: { fontSize: 11, },
    },]
  }

  self.setBody = (sheet, wagons, wagonIds) => {
    wagons = wagons.filter(wagon => wagonIds.indexOf(wagon.id) >= 0)
    for (let i = 0; i < wagons.length; i++) {
      const wagon = wagons[i]

      self.getBodyCells(wagon, i).forEach(cellInfo => {
        excelUtils.setCell(sheet, cellInfo)
      })
    }

    self.getFooterCells(wagons.length).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })

    sheet.row(wagons.length + firstRow + 2).height(40)
  }

  self.getBodyCells = (_wagon, _index) => {
    const weight = computeWeight.getAxletreesWeight(_wagon.axletrees)
      + computeWeight.getSterilesWeight(_wagon.steriles)
    const currentRow = firstRow + _index
    const axletreesRestitues = _wagon.axletrees.filter(a => a.decision === 'Restitué')

    return [{
      name: `A${currentRow}`,
      value: _wagon.id,
      type: types.wagonId,
      style: excelStyles.blCell(),
    }, {
      name: `B${currentRow}`,
      value: _wagon.tare,
      type: types.decimal,
      style: excelStyles.blCell(),
    }, {
      name: `C${currentRow}`,
      value: _wagon.steriles.length || 0,
      mergeRange: `C${currentRow}:D${currentRow}`,
      style: excelStyles.blCell(),
    }, {
      name: `E${currentRow}`,
      value: weight || 0,
      type: types.decimal,
      style: excelStyles.blCell(),
    }, {
      name: `F${currentRow}`,
      value: `=B${currentRow}-E${currentRow}`,
      style: excelStyles.blCell(),
      type: types.decimal,
    }, {
      name: `G${currentRow}`,
      value: _wagon.pieces.length || 0,
      mergeRange: `G${currentRow}:H${currentRow}`,
      style: excelStyles.blCell(),
    }, {
      name: `I${currentRow}`,
      value: axletreesRestitues.length || 0,
      mergeRange: `I${currentRow}:K${currentRow}`,
      style: excelStyles.blCellBold(),
    },]
  }

  self.getFooterCells = (_rowIndex) => {
    const lastLine = firstRow + _rowIndex

    return [{
      name: `A${lastLine}`,
      value: `Total`,
      style: excelStyles.blEndArray(),
    }, {
      name: `B${lastLine}`,
      value: `=SUM(B${firstRow}:B${lastLine - 1})`,
      type: types.decimal,
      style: excelStyles.blEndArray(),
    }, {
      name: `E${lastLine}`,
      value: `=SUM(E${firstRow}:E${lastLine - 1})`,
      type: types.decimal,
      style: excelStyles.blEndArray(),
    }, {
      name: `F${lastLine}`,
      value: `=SUM(F${firstRow}:F${lastLine - 1})`,
      type: types.decimal,
      style: excelStyles.blEndArray(),
    }, {
      name: `C${lastLine}`,
      mergeRange: `C${lastLine}:D${lastLine}`,
      style: excelStyles.blEndArray(),
    }, {
      name: `G${lastLine}`,
      mergeRange: `G${lastLine}:H${lastLine}`,
      style: excelStyles.blEndArray(),
    }, {
      name: `I${lastLine}`,
      mergeRange: `I${lastLine}:K${lastLine}`,
      style: excelStyles.blEndArray(),
    }, {
      name: `A${lastLine + 2}`,
      value: `Pour SGM`,
      style: excelStyles.blFooter(),
    }, {
      name: `B${lastLine + 2}`,
      value: `Damien WAGNER`,
      mergeRange: `B${lastLine + 2}:C${lastLine + 2}`,
      style: excelStyles.blFooter(),
    }, {
      name: `F${lastLine + 2}`,
      value: `Pour`,
      mergeRange: `F${lastLine + 2}:G${lastLine + 2}`,
      style: excelStyles.blFooter(),
    }, {
      name: `H${lastLine + 2}`,
      mergeRange: `H${lastLine + 2}:I${lastLine + 2}`,
      style: excelStyles.blFooter(),
    },]
  }

  return self
}
export default blWagonsExcel



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/scrapping/blWagonsExcel.service.js